module.exports = __webpack_public_path__ + "static/img/2dbg_1.37a20d05.png";